module.exports = __webpack_public_path__ + "assets_1773307907123/img/guide_ios.431fc979.png";